/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Config, CreateConnectorFn } from 'wagmi';
import { connect, disconnect } from 'wagmi/actions';

import type { Chains } from '../types';

import { getSupportedChainNames } from './get-supported-chain-names';

export const connectToAdapter = async (config: Config, connector: CreateConnectorFn, supportedChains: Chains) => {
  const connectResult = await connect(config, { connector });
  const found = supportedChains.findIndex(({ id }) => id === connectResult.chainId) === -1;

  if (!connectResult || !found) {
    return connectResult;
  }

  await disconnect(config);

  if (config.state.current) {
    const activeConnector = config.state.connections.get(config.state.current)?.connector;

    if (activeConnector) {
      const provider: any = await activeConnector.getProvider();
      provider.once('chainChanged', () => globalThis.window?.location.reload());
    }
  }

  throw new Error(`You've changed to wrong network. Please, choose ${getSupportedChainNames(supportedChains)}`);
};
